import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleHostClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const hostSection = document.getElementById('host');
        if (hostSection) {
          hostSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const hostSection = document.getElementById('host');
      if (hostSection) {
        hostSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-outfit font-800 text-black">
              AI <span className="text-crimson">Day</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/events" className="text-black hover:text-crimson transition-colors font-outfit font-600">
              Events
            </Link>
            <a href="/#host" onClick={handleHostClick} className="text-black hover:text-crimson transition-colors font-outfit font-600">
              Partner With Us
            </a>
            <a 
              href="https://aianytime.net/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-black hover:text-crimson transition-colors font-outfit font-600"
            >
              AI Anytime
            </a>
            <a href="/#host" onClick={handleHostClick} className="btn-primary">
              Host AI Day
            </a>
          </nav>

          <button
            className="md:hidden text-black"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/events" 
                className="text-black hover:text-crimson transition-colors font-outfit font-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Events
              </Link>
              <a 
                href="/#host" 
                className="text-black hover:text-crimson transition-colors font-outfit font-600"
                onClick={handleHostClick}
              >
                Partner With Us
              </a>
              <a 
                href="https://aianytime.net/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black hover:text-crimson transition-colors font-outfit font-600"
              >
                AI Anytime
              </a>
              <a 
                href="/#host" 
                className="btn-primary inline-block text-center"
                onClick={handleHostClick}
              >
                Host AI Day
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
